import * as React from 'react';

import { Button } from '@coursera/cds-core';

import _t from 'i18n!nls/course-cards';

const SkillPathwayTakeAssessmentButton = ({ courseId }: { courseId: string }) => {
  return (
    <Button variant="ghost" size="small" style={{ marginTop: '12px' }}>
      {_t('Take skill assessment')}
    </Button>
  );
};

export default SkillPathwayTakeAssessmentButton;
